module.exports = __webpack_public_path__ + "img/schlosserei-raichle-team.31f93536.webp";